module.exports = __webpack_public_path__ + "img/Home-07.4b011fc0.svg";